import { Component, Input,  OnInit, Output } from '@angular/core';
import { FormArray, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValoreAttributo } from '../../../common/model/valoreattributo.model';

@Component({
    selector: 'app-form-layout-valore-attributi',
    template: `

    <div [formGroup]="attributiForm">
      <div formArrayName="{{formAttributiName}}" *ngFor="let valoreattributo of result; let i=index">
        <app-control-text 
          [append]="'times text-danger btn btn-sm btn-link'" 
          (onAppendClick)="removeItem($event)" 
          [ttipAppend]="'Rimuovi'"
          [appendParam]="i" 
          [prepend]="prepend" 
          [label]="''" 
          formControlName="{{i}}">
        </app-control-text>
      </div>
    </div>
     `,
    styles: [],
    standalone: false
})
export class FormTemplateValoreAttributiComponent implements OnInit {
  
  @Input() @Output() attributiForm: FormGroup;

  @Input() valoreattributi: ValoreAttributo[];

  @Input() prepend: string;

  @Input() filter: string;

  @Input() formAttributiName: string = 'attributiArray';

  @Input() validator = Validators.required;

  result: ValoreAttributo[] = [];

  public minusCallback: Function;

  constructor(private _formBuilder: FormBuilder) {
  }

  public ngOnInit() {
    this.minusCallback = this.removeItem.bind(this);
    this.attributiForm.addControl(this.formAttributiName, this._formBuilder.array([]));
    if (this.valoreattributi!=undefined) {
      this.valoreattributi.forEach((valoreAttributo: ValoreAttributo) => {
        if (valoreAttributo.attributo.nome == this.filter) {
          this.addItem(valoreAttributo);
        }
      });
    }
  }
  
  get attributiArray() {
    return this.attributiForm.get(this.formAttributiName) as FormArray;
  }

  addItem(item: ValoreAttributo) {
    this.result.push(item);
    this.attributiArray.push(this._formBuilder.control(
        item.valoreText, [this.validator, Validators.required]
      )
    );
  }

  removeItem(index: number) {
    this.result.splice(index, 1);
    this.attributiArray.removeAt(index);
  }
}
